import { debounce } from '../_functions';

document.addEventListener("DOMContentLoaded", function (dom) {
    const container = dom.target;

    const productList = container.querySelectorAll('.feed-product');
    const searchInput = container.querySelector('.js-product-search-input');
    const categorySelect = container.querySelector('.js-product-category');
    const orderSelect = container.querySelector('.js-product-order');

    const filters = container.querySelector('.js-filters');
    const openFiltersBtn = container.querySelector('.js-open-filters');
    const closeFiltersBtn = container.querySelector('.js-close-filters');

    if (productList.length && searchInput) {

        const getPrice = (el) => {
            return parseFloat(el.dataset.price || 0);
        };

        const getTitle = (el) => {
            const title = el.querySelector('.wrapper__title');
            return title ? title.innerText.toLowerCase() : '';
        };

        const filterAndSortProducts = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();

            let productsArray = Array.from(productList);

            productsArray.forEach(post => {
                const titleText = getTitle(post);
                const postTerms = JSON.parse(post.dataset.terms || '[]');

                const matchSearch = searchTerm === '' || titleText.includes(searchTerm);
                const matchCategory = categorySelect.value === '' || postTerms.includes(categorySelect.value);

                post.classList.toggle('hidden', !(matchSearch && matchCategory));
            });

            const order = orderSelect.value;

            productsArray.sort((a, b) => {
                switch (order) {
                    case 'price-asc':
                        return getPrice(a) - getPrice(b);
                    case 'price-desc':
                        return getPrice(b) - getPrice(a);
                    case 'alpha-asc':
                        return getTitle(a).localeCompare(getTitle(b));
                    case 'alpha-desc':
                        return getTitle(b).localeCompare(getTitle(a));
                    default:
                        return 0;
                }
            });

            const productsWrapper = productList[0].parentNode;

            const fragment = document.createDocumentFragment();
            productsArray.forEach(el => fragment.appendChild(el));
            productsWrapper.appendChild(fragment);
        };

        const handleInput = debounce(filterAndSortProducts, 300);

        searchInput.addEventListener('input', handleInput);
        categorySelect.addEventListener('change', filterAndSortProducts);
        orderSelect.addEventListener('change', filterAndSortProducts);

        filterAndSortProducts();
    }

    // 👉 Gestion ouverture / fermeture filtres
    if (filters && openFiltersBtn && closeFiltersBtn) {
        openFiltersBtn.addEventListener('click', () => {
            filters.style.display = 'block';
        });

        closeFiltersBtn.addEventListener('click', () => {
            filters.style.display = 'none';
        });
    }
});